import {useMutation} from "@tanstack/react-query";
import {apiPostAction} from "../../../../../data/api/explore";

export const usePostAction = () => {
    return useMutation({
        mutationFn: (data) => apiPostAction(data)
    })
}